import { createFileRoute } from '@tanstack/react-router';
import { getDefaultStore } from 'jotai';

import { lastOpenProjectAtom } from '#state/atoms/last-open-project-atom.js';

export const Route = createFileRoute('/_authorization-gate/orgs/$orgName')({
	beforeLoad: ({ params: { orgName } }) => {
		getDefaultStore().set(lastOpenProjectAtom, (prev) => ({
			...prev,
			orgName,
		}));
	},
});
